import { AuthProvider as PropelAuthProvider, useAuthInfo } from '@propelauth/react';
import { ReactNode } from 'react';

import { Spinner } from '@/components/ui/spinner';

interface AuthProviderProps {
  children: ReactNode;
  authUrl: string;
  onAuthSuccess?: () => void;
}

export function AuthProvider({ children, authUrl, onAuthSuccess }: AuthProviderProps) {
  return (
    <PropelAuthProvider authUrl={authUrl}>
      <AuthProviderInner onAuthSuccess={onAuthSuccess}>{children}</AuthProviderInner>
    </PropelAuthProvider>
  );
}

interface AuthProviderInnerProps {
  children: ReactNode;
  onAuthSuccess?: () => void;
}

function AuthProviderInner({ children, onAuthSuccess }: AuthProviderInnerProps) {
  const { loading } = useAuthInfo();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size={24} />
      </div>
    );
  }

  return <>{children}</>;
}

// Re-export PropelAuth hooks for convenience
export { useAuthInfo, useLogoutFunction, useRedirectFunctions } from '@propelauth/react';
